module.exports = __webpack_public_path__ + "static/media/Mailing-Clergy-CAMPAIGN.4048236e.pdf";